<script setup lang="ts">
import { useClipboard, whenever } from '@vueuse/core'

defineProps<{
  content: string
}>()

const { copy, copied } = useClipboard()

const { displaySuccess } = useToast()

whenever(copied, () => {
  console.log('copy')
  displaySuccess('Copied to clipboard!')
})
</script>

<template>
  <BaseButton @click="copy(content)">
    {{ copied ? "Copied " : "Copy to clipboard" }}
  </BaseButton>
</template>
